module.exports = __webpack_public_path__ + "img/gl.3fd508eb.svg";